import {
  RECENT_LOCATIONS_SUCCESS,
  RECENT_LOCATIONS_REQUEST,
  RECENT_LOCATIONS_FAILURE,
} from '../../actions/types';

import { formatUKPostcode } from '../../utils/geolocation';

const initialState = {
  loading: false,
  error: null,
  locations: [],
};

function formatAddress(address) {
  // formatUKPostcode will ignore any format it doesn’t match
  return [address.address1, address.address2, address.city, formatUKPostcode(address.post_code)]
    .filter(Boolean)
    .join(', ');
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case RECENT_LOCATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };
    case RECENT_LOCATIONS_SUCCESS:
      return {
        loading: false,
        locations: action.payload.addresses.map((address) => ({
          id: address.id.toString(),
          formattedAddress: formatAddress(address),
          postcode: address.post_code,
          placeId: address.place_id,
          coordinates: address.coordinates,
          city: address.city,
        })),
      };
    case RECENT_LOCATIONS_FAILURE:
      return {
        loading: false,
        error: {
          status: action.status,
        },
        locations: [],
      };
    default:
      return state;
  }
}
